module.exports = __webpack_public_path__ + "img/empty.82f09101.jpg";